module.exports = __webpack_public_path__ + "static/media/task-gray.cfa1a0d1.svg";